export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REFRESH_SUCCESS = 'REFRESH_SUCCESS';
export const HYDRATE_USER = 'HYDRATE_USER';
export const REFRESH_FAILED = 'REFRESH_FAILED';
